import { Typography } from '@components/typography';
import { Container, Grid, Stack, useTheme } from '@mui/material';
import type { LogType } from './types';

type LogsRowProps = {
  log: LogType;
  variant?: 'horizontal' | 'vertical';
};

export const LogsRow = ({ log, variant = 'horizontal' }: LogsRowProps) => {
  const { palette } = useTheme();
  const isoTimestamp =
    typeof log.timestamp === 'string'
      ? log.timestamp // assume already in ISO format
      : new Date(log.timestamp).toISOString();

  if (variant === 'vertical') {
    return (
      <Container maxWidth="lg">
        <Stack pb={2}>
          <Typography variant="body2" color={palette.text.paper}>
            {isoTimestamp}
          </Typography>
          <Typography variant="body2" color={palette.text.paper}>
            {log.message}
          </Typography>
        </Stack>
      </Container>
    );
  }

  return (
    <Grid container px={2} py={1}>
      <Grid item xs={1.5}>
        <Typography variant="body2" color={palette.text.paper}>
          {isoTimestamp}
        </Typography>
      </Grid>
      <Grid item xs={10.5} style={{ overflowWrap: 'break-word' }}>
        <Typography variant="body2" color={palette.text.paper}>
          {log.message}
        </Typography>
      </Grid>
    </Grid>
  );
};
